import axios from "axios";
import { SnackbarKey, SnackbarMessage } from "notistack";

export const Helpers = {
    /**
     * Função que verifica se a URL é uma imagem.
     * @param url
     */
    isImageURL: function (url: string): boolean {
        var types = ['jpg', 'jpeg', 'tiff', 'png', 'gif', 'bmp'];
        var parts = url.split('.');
        var extension = parts[parts.length - 1];
        if (types.indexOf(extension) !== -1) {
            return true;
        }
        return false;
    },

    download: function (response: any, filename: string) {
        const type = response.headers['content-type'];
        const blob = new Blob([response.data], { type: type });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
    },

    downloadURL: function (url: string, filename: string) {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },

    upload: function () {
        const link = document.createElement('input:file');
        link.click();
    },

    /**
     * Função que trata os retornos de erro do backend.
     * @param error
     * @param alert
     */
    error: function (error: any, alert: (message: SnackbarMessage) => SnackbarKey) {
        if (
            axios.isAxiosError(error) &&
            error.response &&
            typeof error.response.data.message === 'string'
        ) {
            alert(error.response.data.message);
        } else {
            alert('Não foi possível realizar a conexão com o servidor.');
        }
    },

    errorFormat: function (error: any) {
        if (
            axios.isAxiosError(error) &&
            error.response &&
            typeof error.response.data.message === 'string'
        ) {
            return error.response.data.message;
        } else {
            return 'Não foi possível realizar a conexão com o servidor.';
        }
    },

    trim: function (str: string, length: number = 16): string {
        return str.length > length ? str.substring(0, length - 3) + "..." : str.substring(0, length);
    }
}